import { useEffect, useState } from "react";

type ScrollEdges = { hasMoreAbove: boolean; hasMoreBelow: boolean };

export const useScrollEdges = <T extends HTMLElement>() => {
  const [node, setNode] = useState<T | null>(null);
  const [edges, setEdges] = useState<ScrollEdges>({ hasMoreAbove: false, hasMoreBelow: false });

  useEffect(() => {
    if (!node) return;
    const update = () =>
      setEdges({
        hasMoreAbove: node.scrollTop > 0,
        hasMoreBelow: node.scrollTop + node.clientHeight < node.scrollHeight - 1,
      });
    update();
    node.addEventListener("scroll", update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(node);
    return () => {
      node.removeEventListener("scroll", update);
      observer.disconnect();
    };
  }, [node]);

  return { ref: setNode, ...edges };
};
